function GradientButton({ children, onClick }) {
    return (
        <button
            onClick={onClick}
            className="olm-gradient w-full max-w-full hover:bg-none hover:bg-secondary shadow-lg text-white px-7 py-4 md:py-6 rounded-md text-xl font-semibold">
            {children}
        </button>
    )
}

export default GradientButton
